import PendingCard from '../PendingsCard';
import PendingReviewSummary from './PendingReviewSummary';
import Trans from '@/components/shared/Trans';
import translations from '../../Dashboard.trans.json';

function PendingReviewCard({
  cardRef,
  loading,
  empty,
  title,
  count,
  viewMode,
  onViewModeChange,
  redirectUrl,
  trackCallback,
  locale,
  emptyState,
  children,
}) {
  return (
    <PendingCard ref={cardRef} loading={loading}>
      <PendingCard.Header
        redirectUrl={empty ? null : redirectUrl}
        toolTipText={Trans(translations, 'ShowAll')}
        trackCallback={trackCallback}
      >
        {title}
      </PendingCard.Header>
      <PendingReviewSummary
        count={count}
        viewMode={viewMode}
        onViewModeChange={onViewModeChange}
        locale={locale}
        trackCallback={trackCallback}
      />
      {empty ? emptyState : children}
    </PendingCard>
  );
}

export default PendingReviewCard;
